module.exports = __webpack_public_path__ + "static/media/uni-cc-06.8f588ccd.png";